import { useSelector } from 'react-redux';
import { orderAutomatizationSelectors } from '../services/selectors';
import { shippingLabelModalSelectors } from '@/ModalWindows/ShippingLabelModal/services';

export const useOrderAutomatizationModalOptions = () => {
  const selectedOrderIds = useSelector(shippingLabelModalSelectors.filteredOrderIdsByWarehouse);
  const editableOrderIds = useSelector(orderAutomatizationSelectors.editableOrderIds);
  const orderPackages = useSelector(orderAutomatizationSelectors.orderPackages);
  const orderAutomatizationRows = useSelector(orderAutomatizationSelectors.orderAutomatizaionRows);

  return {
    orderPackages,
    selectedOrderIds,
    editableOrderIds,
    orderAutomatizationRows,
  };
};
